import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const ReturnsCountry = {
  id: 'returnsCountry',
  displayName: <FormattedMessage {...messages.country} />,
  type: OptionFormTypes.TYPE_IS_OPTIONS,
  filterValue: 'returnFromCountryCode',
  allowsMultipleSelection: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_OPTIONS, criteriaInformations, existingFiltersHelpers);
  },
};
